<script>
	import OurAdvantages from '../(components)/OurAdvantages.svelte';
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import CategoryList from '../skutr-[slug]/CategoryList.svelte';
	import {resolveImageByUrl} from "$lib/helpers/universalCategoryImageByUrlResolver";
	import { _CategoriesEnum } from '$lib/utils/Enums';
	export let data;
	export let breadcrumbs = [{ name: 'Univerzální díly', link: 'univerzalni-dily' }];
</script>

<svelte:head>
	<title>Univerzální díly na skútry</title>
	<meta name="description" content="Univerzální díly použitelné na velké množství různých skútrů. Je ale možné, že díl nebude na váš konkrétní model pasovat. Prosím porovnejte díl s fotografií a parametry v popisu."/>
	<link rel="canonical" href={`https://www.scootland.cz/univerzalni-dily/`} />
	<meta property="og:title" content="Univerzální díly na skútry" />
	<meta property="og:description" content="Univerzální díly použitelné na velké množství různých skútrů. Je ale možné, že díl nebude na váš konkrétní model pasovat. Prosím porovnejte díl s fotografií a parametry v popisu."/>
	<meta property="og:image" content="/image/og-hp.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/univerzalni-dily/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>

<Breadcrumb {breadcrumbs} />

<section class="container mx-auto mb-24 mt-10 px-2.5 md:px-0">
	<h1 class="font-heading mb-3 text-center text-2xl font-bold sm:text-3xl">Univerzální díly</h1>

	<p class="mx-auto mb-16 w-full max-w-3xl text-center text-base leading-normal">
		Zde najdete univerzální díly použitelné na velké množství různých skútrů. Je ale možné, že díl
		nebude na váš konkrétní model pasovat. Prosím porovnejte díl s fotografií a parametry v popisu.
	</p>

	<div class="rozkresy:hover flex flex-col gap-y-6 sm:grid sm:grid-cols-2 sm:gap-7 lg:grid-cols-3">
		<CategoryList categories={data.categories} categoryType={_CategoriesEnum.universal} />
	</div>
</section>

<OurAdvantages class="container mx-auto border-t-2 border-gray-concrete" />
